import { devices_config } from '@devices/index';
import type { Device } from 'src/types/Device';

export function deviceHasSettingTitle(device: Device, title: string): boolean {
	const modes = devices_config[device.type]?.modes ?? {};
	const modeKey = device.mode && modes[device.mode] ? device.mode : Object.keys(modes)[0];
	const groups = modes[modeKey]?.settings ?? [];
	return groups.some(
		(group: { title?: string; components?: { title?: string }[] }) =>
			group.title === title || group.components?.some((c) => c.title === title),
	);
}
